import { useTranslation } from 'react-i18next';

export default function SellerVatIdsEmpty() {
  const { t } = useTranslation();
  return (
    <div className='Page flex-grow-1'>
      <div className='container'>
        <div className='Paper Paper--sm mx-auto py-3'>
          <div className='px-4'>
            <div className='SellerVATIds__title fw-900 mb-2'>
              {t('International VAT')}
            </div>
            <div className='multiline mb-3'>
              {t(
                "You don't have any active VAT IDs under countX management. Information about OSS details will be available later."
              )}
            </div>
            <div
              style={{
                maxWidth: 532,
              }}
            >
              <div className='d-grid SellerVATIds__emptyGrid mb-2'>
                <div className='Text--gray'>{t('Country')}</div>
                <div className='Text--gray'>{t('VAT ID')}</div>
                <div className='Text--gray'>{t('Tax ID')}</div>
              </div>
              <div className='d-grid SellerVATIds__emptyGrid'>
                <div>
                  {[157, 168, 133, 183, 133].map((maxWidth, i) => (
                    <Line maxWidth={maxWidth} key={i} />
                  ))}
                </div>
                <div>
                  {Array(5)
                    .fill(1)
                    .map((_, i) => (
                      <TwoPartsLine key={i} />
                    ))}
                </div>
                <div>
                  {Array(5)
                    .fill(1)
                    .map((_, i) => (
                      <TwoPartsLine key={i} />
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Line = ({ maxWidth }: { maxWidth: number }) => (
  <div
    className='SellerVATIds__line mb-4 rounded'
    style={{
      maxWidth,
    }}
  />
);

const TwoPartsLine = () => (
  <div className='d-flex mb-4'>
    <div className='SellerVATIds__line rounded me-1 flex-grow-1' />
    <div
      className='SellerVATIds__line--green rounded'
      style={{
        width: 21,
      }}
    />
  </div>
);
